import { createContext, useContext, useState, useCallback } from 'react';

const ChatContext = createContext(null);

export const ChatProvider = ({ children }) => {
  const [activeChat, setActiveChat] = useState(null); // { eventId, eventName, eventImage }
  const [isOpen, setIsOpen] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);

  const openChat = useCallback((eventId, eventName, eventImage = null) => {
    setActiveChat({ eventId, eventName, eventImage });
    setIsOpen(true);
    setUnreadCount(0);
  }, []);

  const closeChat = useCallback(() => {
    setIsOpen(false);
  }, []);

  const dismissChat = useCallback(() => {
    setIsOpen(false);
    setActiveChat(null);
    setUnreadCount(0);
  }, []);

  const toggleChat = useCallback(() => {
    setIsOpen(prev => !prev);
    if (!isOpen) setUnreadCount(0);
  }, [isOpen]);

  const addUnread = useCallback(() => {
    setUnreadCount(prev => prev + 1);
  }, []);

  const clearUnread = useCallback(() => {
    setUnreadCount(0);
  }, []);

  return (
    <ChatContext.Provider value={{
      activeChat,
      isOpen,
      unreadCount,
      openChat,
      closeChat,
      dismissChat,
      toggleChat,
      addUnread,
      clearUnread,
      setUnreadCount
    }}>
      {children}
    </ChatContext.Provider>
  );
};

export const useChat = () => {
  const ctx = useContext(ChatContext);
  if (!ctx) throw new Error('useChat must be used within ChatProvider');
  return ctx;
};
